import React from "react";
import "../styles/Experience.css";
import { companyDuration, resolvePeriod, positionDuration } from "../utils/duration";

const Experience = ({ experience, section = {} }) => {
  return (
    <section
      className="experience section wow animate__animated animate__fadeInUp"
      id="experience"
    >
      <span className="section__subtitle">{section.subtitle}</span>
      <h2 className="section__title">{section.title}</h2>

      <div className="experience__container">
        {experience.map((company, companyIndex) => {
          const companyDur = companyDuration(company.positions) || company.duration;
          return (
          <div key={companyIndex} className="experience__company">
            <div className="experience__company-header">
              <div className="experience__company-icon">
                <i className="fas fa-building"></i>
              </div>
              <div className="experience__company-info">
                <h3 className="experience__company-name">{company.company}</h3>
                <span className="experience__company-meta">
                  {company.type}
                  {companyDur ? ` · ${companyDur}` : ""}
                </span>
                <span className="experience__company-location">
                  <i className="fas fa-map-marker-alt"></i> {company.location}
                </span>
              </div>
            </div>

            <div className="experience__timeline">
              {company.positions.map((position, posIndex) => {
                const periodLabel = resolvePeriod(position) || position.period;
                const posDur = positionDuration(position);
                return (
                <div
                  key={posIndex}
                  className={`experience__position ${
                    posIndex === company.positions.length - 1 ? "last" : ""
                  }`}
                >
                  <div className="experience__timeline-marker">
                    <div className="experience__timeline-dot"></div>
                    {posIndex !== company.positions.length - 1 && (
                      <div className="experience__timeline-line"></div>
                    )}
                  </div>

                  <div className="experience__position-content">
                    <div className="experience__position-header">
                      <h4 className="experience__position-title">
                        {position.title}
                      </h4>
                      <span className="experience__position-period">
                        {periodLabel}
                        {posDur ? ` · ${posDur}` : ""}
                      </span>
                    </div>

                    {position.team && (
                      <span className="experience__position-team">
                        {position.team}
                      </span>
                    )}

                    <ul className="experience__highlights">
                      {position.highlights.map((highlight, hIndex) => (
                        <li key={hIndex} className="experience__highlight-item">
                          {highlight}
                        </li>
                      ))}
                    </ul>

                    {position.metrics && position.metrics.length > 0 && (
                      <div className="experience__metrics">
                        {position.metrics.map((metric, mIndex) => (
                          <div key={mIndex} className="experience__metric">
                            <span className="experience__metric-value">
                              {metric.value}
                            </span>
                            <span className="experience__metric-label">
                              {metric.label}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                );
              })}
            </div>
          </div>
          );
        })}
      </div>
    </section>
  );
};

export default Experience;

